function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isUserCustomer } from '@rd-web-markets/shared/dist/util/user/userUtils';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const checkboxFieldNamesClient = ['is_financial', 'is_technical'];
const checkboxFieldNamesInternalUsers = ['is_financial', 'is_technical', 'is_internal_only'];
const checkboxTranslationValues = {
  is_financial: 'financial',
  is_technical: 'technical'
  // is_internal_only: 'internal_only' // option only relevant for internal users
};
const TypeCheckboxes = _ref => {
  var _userClaimGroupAbilit;
  let {
    body,
    setBody,
    labelText,
    userClaimGroupAbilities
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const documentTypeAbilities = userClaimGroupAbilities === null || userClaimGroupAbilities === void 0 || (_userClaimGroupAbilit = userClaimGroupAbilities.pages) === null || _userClaimGroupAbilit === void 0 ? void 0 : _userClaimGroupAbilit.any;
  let checkboxFieldNames = checkboxFieldNamesClient;
  const hasDocumentTypeAbilities = !!documentTypeAbilities;
  if (isUserCustomer(user) && hasDocumentTypeAbilities) {
    checkboxFieldNames = checkboxFieldNamesClient.filter(fieldName => {
      if (fieldName === 'is_financial') return documentTypeAbilities.canAccessFinancialDocuments;
      if (fieldName === 'is_technical') return documentTypeAbilities.canAccessTechnicalDocuments;
      return false;
    });
  }

  // option only relevant for internal users
  if (!isUserCustomer(user)) {
    checkboxTranslationValues['is_internal_only'] = 'internal_only';
    checkboxFieldNames = checkboxFieldNamesInternalUsers;
  }
  const onlyOneDocumentTypeAvailable = checkboxFieldNames.length === 1 && isUserCustomer(user);
  const {
    t
  } = useTranslation();
  const changeCheckbox = e => {
    return setBody(body => _objectSpread(_objectSpread({}, body), {}, {
      [e.target.name]: e.target.checked
    }));
  };
  return checkboxFieldNames.map((fieldName, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Form.Label, {
      column: "md",
      md: 3
    }, index === 0 && t(labelText)), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 5,
        offset: 4
      }
    }, /*#__PURE__*/React.createElement(Form.Check, {
      id: fieldName,
      type: "checkbox",
      name: fieldName,
      checked: body[fieldName] || false,
      value: body[fieldName] || false,
      onChange: changeCheckbox,
      label: t(checkboxTranslationValues[fieldName]),
      disabled: onlyOneDocumentTypeAvailable
    }))));
  });
};
export default TypeCheckboxes;